import { gql } from "@apollo/client";
import { BagType } from "../types/ConsolidationTypes";

export const EXECUTE_CONSOLIDATION_ASYNC = gql`
    mutation ExecuteConsolidationAsync($input: ExecuteConsolidationTypeInput!) {
        executeConsolidationAsync(input: $input) {
            success
            bagTaskLogId
            message
        }
    }
`;

export interface ExecuteConsolidationAsyncVariables {
    input: {
        warehouseId: string;
        destinationHubId?: string;
        destinationHubName?: string;
        destinationWhsId?: string | null;
        destinationWhsName?: string;
        expectedDeliveryTimeStart?: string;
        expectedDeliveryTimeEnd?: string;
        bagType?: BagType;
        carrier?: number; // 新增carrier字段
    };
}

export interface ExecuteConsolidationAsyncResponse {
    executeConsolidationAsync: {
        success: boolean;
        bagTaskLogId: string;
        message?: string;
    };
}
